import { createAsyncThunk } from '@reduxjs/toolkit';
import { ICompleteAction, IRegisterAction } from 'core/slices/register';
import {
  IAttemptAction,
  ICertificateAction,
  ICertificateResponse,
  IDialogueAction,
  IGroupPermissionAction,
  IGroupPermissionResponse,
  IHomeResponse,
  IModuleAction,
  IModuleResponse,
  ISuspenseAction,
  ISystemPermissionAction,
  ISystemPermissionResponse,
  ITokenAction,
  ITokenActionResponse,
  IVerificationAction,
} from 'types/action/player';
import { ISearch, SearchType } from 'types/domain/search';

import { ISessionAction, ISessionAttempt } from 'types/domain/session';
import { AxiosWrapper } from './axios.wrapper';
import { IAuthResponse } from 'types/session/auth';
import { IError } from 'types/app/error';

export const tokenRequest = createAsyncThunk('learner/token', async (data: ITokenAction) => {
  const response = await AxiosWrapper.post('/api/learner/token', data);
  return response.data as ITokenActionResponse;
});

export const homeRequest = createAsyncThunk('learner/home', async () => {
  const response = await AxiosWrapper.get('/api/learner/home');
  return response.data as IHomeResponse;
});

export const groupPermissionRequest = createAsyncThunk('learner/group', async (data: IGroupPermissionAction) => {
  const response = await AxiosWrapper.post('learner/group', data);
  return response.data as IGroupPermissionResponse;
});

export const systemPermissionRequest = createAsyncThunk('learner/system', async (data: ISystemPermissionAction) => {
  const response = await AxiosWrapper.post('learner/system', data);
  return response.data as ISystemPermissionResponse;
});

export const moduleRequest = createAsyncThunk('learner/module', async (data: IModuleAction) => {
  if (data.url) {
    const response = await AxiosWrapper.getJson(data.url, {
      credentials: 'include',
    });
    return response.data as IModuleResponse;
  } else {
    const response = await AxiosWrapper.post(`/api/learner/module`, data);
    return response.data as IModuleResponse;
  }
});

export const certificateRequest = createAsyncThunk('learner/certificate', async (data: ICertificateAction) => {
  const response = await AxiosWrapper.post('/api/learner/certificate', data);
  return response.data as ICertificateResponse;
});

export const attemptRequest = createAsyncThunk('learner/attempt', async (data: IAttemptAction, { rejectWithValue }) => {
  const response = await AxiosWrapper.post('/api/learner/attempt', data);
  return response.data as ISessionAttempt;
});

export const suspenseRequest = createAsyncThunk('learner/suspense', async (data: ISuspenseAction) => {
  const response = await AxiosWrapper.post('/api/learner/suspense', data);
  return response.data;
});

export const verificationRequest = createAsyncThunk('learner/verification', async (data: IVerificationAction) => {
  const response = await AxiosWrapper.post('/api/learner/verification', data);
  return response.data;
});

export const dialogueRequest = createAsyncThunk('learner/dialogue', async (data: IDialogueAction) => {
  const response = await AxiosWrapper.post('/api/learner/dialogue', data);
  return response.data;
});

export const actionRequest = createAsyncThunk('learner/action', async (data: IRegisterAction) => {
  const response = await AxiosWrapper.post('/api/learner/action', data);
  return response.data;
});

export const completeRequest = createAsyncThunk('learner/complete', async (data: ICompleteAction) => {
  const response = await AxiosWrapper.post('/api/learner/complete', data);
  return response.data;
});

export const searchRequest = createAsyncThunk('learner/search', async (data: ISearch) => {
  const response = await AxiosWrapper.post(
    data.searchType === SearchType.LEARNER ? '/api/learner/search' : '/api/admin/search',
    data,
  );
  return response.data;
});



export const configRequest = createAsyncThunk('config', async (domain: string) => {
  const response = await AxiosWrapper.getJson(`/public/domain/${domain}/config.json`, { credentials: 'include' });
  return response.data;
});

export const errorRequest = createAsyncThunk('error', async (data: IError) => {
  const response = await AxiosWrapper.post(`/api/error`, data);
  return response.data;
});
